// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__TVzo6","list":"PatternAutocomplete_list__d_HEc"};